import {
    HARDCODED_PINS_PROPERTY_TYPE_ID,
    MAX_PIN_SEND_COUNT_PROPERTY_TYPE_ID,
    MAX_PIN_VERIFY_COUNT_PROPERTY_TYPE_ID,
    MAX_VERIFICATION_COUNT_PROPERTY_TYPE_ID,
    PIN_TIMEOUT_PROPERTY_TYPE_ID,
    MOCK_SEND_EMAIL_PIN_PROPERTY_TYPE_ID
} from "@constants/pin-code-constants";
import {
    FormattedRpServiceConfigurationProperty,
    FormattedRpServiceConfigurationServiceOffering
} from "@idw-types/data/rp-service-configuration";
import { FormattedAppliedProfile } from "@idw-types/data/applied-profile/applied-profile";
import { getRpServicePropertyValueOrAppliedProfilePropertyValue } from "@utils/applied-profile-util";
import {
    AMAZON_SNS_PIN_SERVICE_OFFERING_ID,
    IDDATAWEB_EMAIL_PIN_AND_PHONE_PIN_SERVICE_OFFERING_ID,
    IDDATAWEB_EMAIL_PIN_SERVICE_OFFERING_ID,
    IDDATAWEB_INTERNATIONAL_PHONE_PIN_SERVICE_OFFERING_ID,
    TELESIGN_SMS_PIN_SERVICE_OFFERING_ID
} from "@constants/verification-service-details-constants";
import { EntityStatusTypes } from "@enums/entity-status-types";

export const getPinCodeProperties = (
    properties: Array<FormattedRpServiceConfigurationProperty>,
    appliedProfiles: Array<FormattedAppliedProfile>
) => {
    const maxPinSendPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, MAX_PIN_SEND_COUNT_PROPERTY_TYPE_ID);
    const maxPinVerifyCountPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, MAX_PIN_VERIFY_COUNT_PROPERTY_TYPE_ID);
    const maxVerificationCountPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, MAX_VERIFICATION_COUNT_PROPERTY_TYPE_ID);
    const pinTimeoutPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, PIN_TIMEOUT_PROPERTY_TYPE_ID);
    const hardcodedPinCodePropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, HARDCODED_PINS_PROPERTY_TYPE_ID);
    const mockSendEmailPinPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, MOCK_SEND_EMAIL_PIN_PROPERTY_TYPE_ID);

    return {
        maxPinSendCount: maxPinSendPropertyValue,
        maxPinVerifyCount: maxPinVerifyCountPropertyValue,
        maxVerificationCount: maxVerificationCountPropertyValue,
        pinTimeout: pinTimeoutPropertyValue,
        hardcodedPinCode: hardcodedPinCodePropertyValue,
        mockSendEmailPin: mockSendEmailPinPropertyValue
    };
};

export const isMaxPinSendProperty = (propertyTypeId: string) => {
    return propertyTypeId === MAX_PIN_SEND_COUNT_PROPERTY_TYPE_ID;
};

export const isMaxPinVerifyCountProperty = (propertyTypeId: string) => {
    return propertyTypeId === MAX_PIN_VERIFY_COUNT_PROPERTY_TYPE_ID;
};

export const isMaxVerificationCountProperty = (propertyTypeId: string) => {
    return propertyTypeId === MAX_VERIFICATION_COUNT_PROPERTY_TYPE_ID;
};

export const isPinTimeoutProperty = (propertyTypeId: string) => {
    return propertyTypeId === PIN_TIMEOUT_PROPERTY_TYPE_ID;
};

export const isHardcodedPinCodeProperty = (propertyTypeId: string) => {
    return propertyTypeId === HARDCODED_PINS_PROPERTY_TYPE_ID;
};

export const isMockSendEmailPinProperty = (propertyTypeId: string) => {
    return propertyTypeId === MOCK_SEND_EMAIL_PIN_PROPERTY_TYPE_ID;
};

export const hasEmailPinServiceOffering = (serviceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>) => {
    return serviceOfferings
        .some(so => so.addedToService && so.status === EntityStatusTypes.ACTIVE && [
            IDDATAWEB_EMAIL_PIN_AND_PHONE_PIN_SERVICE_OFFERING_ID,
            IDDATAWEB_EMAIL_PIN_SERVICE_OFFERING_ID
        ].includes(so.serviceOfferingID));
};

export const hasSmsPinServiceOffering = (serviceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>) => {
    return serviceOfferings
        .some(so => so.addedToService && so.status === EntityStatusTypes.ACTIVE && [
            IDDATAWEB_EMAIL_PIN_AND_PHONE_PIN_SERVICE_OFFERING_ID,
            IDDATAWEB_INTERNATIONAL_PHONE_PIN_SERVICE_OFFERING_ID,
            TELESIGN_SMS_PIN_SERVICE_OFFERING_ID,
            AMAZON_SNS_PIN_SERVICE_OFFERING_ID
        ].includes(so.serviceOfferingID));
};

export const hasPinServiceOffering = (serviceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>) => {
    return serviceOfferings
        .some(so => so.addedToService && so.status === EntityStatusTypes.ACTIVE && [
            IDDATAWEB_EMAIL_PIN_AND_PHONE_PIN_SERVICE_OFFERING_ID,
            IDDATAWEB_EMAIL_PIN_SERVICE_OFFERING_ID,
            IDDATAWEB_INTERNATIONAL_PHONE_PIN_SERVICE_OFFERING_ID,
            TELESIGN_SMS_PIN_SERVICE_OFFERING_ID,
            AMAZON_SNS_PIN_SERVICE_OFFERING_ID
        ].includes(so.serviceOfferingID));
};